import { useMemo } from "react"

import { Col, Row, Space, Spin, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Images from "../../../../Images"
import { formatCurrency } from "../../../../Utils/utils"

import "./styles.less"

const { Text } = Typography

export default function AlertsBySourceTable({ data, loading = false }) {
  const { theme, isMobile } = useSelector((state) => state.nav)
  const { t } = useTranslation()

  const tableRows = useMemo(() => {
    return [
      {
        source: {
          text: "Ethoca",
          icon: <img src={Images.mastercard} />,
          iconDark: <img src={Images.mastercard} />
        },
        total: data?.ethoca_total ?? 0,
        paid: data?.ethoca_paid ?? 0,
        reward: data?.ethoca_reward ?? 0
      },
      {
        source: {
          text: "RDR",
          icon: <img src={Images.verifi} />,
          iconDark: <img src={Images.verifi} />
        },
        total: data?.rdr_total ?? 0,
        paid: data?.rdr_paid ?? 0,
        reward: data?.rdr_reward ?? 0
      },
      {
        source: {
          text: "CDRN",
          icon: <img src={Images.verifi} />,
          iconDark: <img src={Images.verifi} />
        },
        total: data?.cdrn_total ?? 0,
        paid: data?.cdrn_paid ?? 0,
        reward: data?.cdrn_reward ?? 0
      }
    ]
  }, [data])
  if (isMobile) {
    return (
      <Spin spinning={loading}>
        <div className="referral-alerts-by-source-cards">
          {tableRows.map((row, i) => (
            <div key={i} className="referral-alerts-by-source-cards__card">
              <div className="referral-alerts-by-source-cards__badge">
                {theme === "dark" ? row.source.iconDark : row.source.icon}
                <span className="referral-alerts-by-source-cards__badge-text">
                  {row.source.text}
                </span>
              </div>
              <div className="referral-alerts-by-source-cards__fields">
                <div className="referral-alerts-by-source-cards__field">
                  <span className="referral-alerts-by-source-cards__label">
                    {t("Total alerts")}
                  </span>
                  <span className="referral-alerts-by-source-cards__value">
                    {row.total.toLocaleString()}
                  </span>
                </div>
                <div className="referral-alerts-by-source-cards__field">
                  <span className="referral-alerts-by-source-cards__label">{t("Paid alerts")}</span>
                  <span className="referral-alerts-by-source-cards__value">
                    {row.paid.toLocaleString()}
                  </span>
                </div>
                <div className="referral-alerts-by-source-cards__field">
                  <span className="referral-alerts-by-source-cards__label">{t("Reward")}</span>
                  <span className="referral-alerts-by-source-cards__value">
                    {formatCurrency(row.reward / 100)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Spin>
    )
  }

  return (
    <Spin spinning={loading}>
      <div className="referral-alerts-by-source-table">
        <Row className="row header">
          <Col span={6}>
            <Text strong type="secondary">
              Source
            </Text>
          </Col>
          <Col span={6} className="col-align-end">
            <Text strong type="secondary">
              Total alerts
            </Text>
          </Col>
          <Col span={6} className="col-align-end">
            <Text strong type="secondary">
              Paid alerts
            </Text>
          </Col>
          <Col span={6} className="col-align-end">
            <Text strong type="secondary">
              Reward
            </Text>
          </Col>
        </Row>

        {tableRows.map((row, i) => (
          <Row key={i} className="row">
            <Col span={6}>
              <Space size={8}>
                {theme === "dark" ? row.source.iconDark : row.source.icon}
                <Text>{row.source.text}</Text>
              </Space>
            </Col>
            <Col span={6} className="col-align-end">
              <Text>{row.total.toLocaleString()}</Text>
            </Col>
            <Col span={6} className="col-align-end">
              <Text>{row.paid.toLocaleString()}</Text>
            </Col>
            <Col span={6} className="col-align-end">
              <Text>{formatCurrency(row.reward / 100)}</Text>
            </Col>
          </Row>
        ))}
      </div>
    </Spin>
  )
}
